import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

/**
 * Displays the header for the clause checklists list.
 */
export const ClauseChecklistsListHeader = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <Stack pb={1}>
            {/* Title */}
            <Typography
                variant={isMobile ? "h5" : "h4"}
                component="h1"
                sx={{
                    fontWeight: 700,
                    color: "#233876",
                    fontSize: "1.5rem",
                    mt: 1,
                    mb: 0.5,
                    wordWrap: "break-word",
                }}
            >
                Checklists
            </Typography>
        </Stack>
    );
};
